module.exports = __webpack_public_path__ + "static/media/previous.f8815734.svg";